import { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import ApiService from '../../services/ApiService';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

/**
 * AppointmentCalendarCancelModal Component
 * A modal for confirming and providing a reason for appointment cancellation.
 *
 * Props:
 * - show: Boolean to control the modal visibility
 * - onHide: Function to close the modal
 * - appointmentId: ID of the appointment to be cancelled
 * - onCancelSuccess: Function to handle successful cancellation (e.g., refresh calendar)
 */
const AppointmentCalendarCancelModal = ({ show, onHide, appointmentId, onCancelSuccess }) => {
  const [notes, setNotes] = useState('');
  const role = Number(localStorage.getItem('role'));
  const { t } = useTranslation();

  // Handle the "Yes" button click
  const handleYes = async () => {
    try {
      if (!notes.trim()) {
        toast.error(t('error.cancelReason'));
        return;
      }

      // Send the cancellation request to the API
      await ApiService.deleteAppointment(appointmentId, { cancelled_reason: notes });

      // Show success toast notification
      toast.success(t('toast.appointmentSuccess'));

      // Trigger the success callback (e.g., refresh the calendar)
      onCancelSuccess();
      onHide();
    } catch (error) {
      // Handle error
      const errorMessage = error?.response?.data?.message || t('toast.appointmentCancel');
      toast.error(errorMessage);
    }
  };

  return (
    <Modal show={show} onHide={onHide} backdrop="static">
      <Modal.Header closeButton className={`${role === 4 ? 'admin-modal-header' : ''}`}>
        <Modal.Title>{t('modal.cancelAppointment')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{t('modal.cancelAppointmentReason')}</p>
        <Form>
          <Form.Group controlId="cancellationNotes">
            <Form.Label>{t('modal.cancelReasonLabel')}</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder={t('modal.enterCancelReason')}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" className={`${role === 4 ? 'btn-tmAquaDgreen' : ''}`} onClick={onHide}>
          {t('modal.no')}
        </Button>
        <Button
          variant="primary"
          className={`${role === 4 ? 'btn-tmAquaGreen' : ''}`}
          onClick={handleYes}
        >
          {t('modal.yes')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AppointmentCalendarCancelModal;
